<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-undo`]" width="1em" height="1em" v-bind="$attrs"><path d="M9.54834 4.28906C11.7697 4.28908 13.3562 5.15684 14.3677 6.48438C15.3586 7.78522 15.7514 9.46484 15.7515 11.0449C15.7513 11.4121 15.4536 11.71 15.0864 11.71C14.7195 11.7097 14.4215 11.4119 14.4214 11.0449C14.4214 9.66018 14.0733 8.29314 13.3091 7.29004C12.5653 6.31408 11.3818 5.61916 9.54834 5.61914C7.73027 5.61925 6.16517 6.43166 4.80029 7.51855C3.92116 8.21869 3.16944 8.99526 2.49268 9.71387H4.4458C4.81298 9.71387 5.11069 10.0118 5.11084 10.3789C5.11063 10.746 4.81294 11.0439 4.4458 11.0439H1.09521C0.87155 11.1072 0.62142 11.054 0.444824 10.8789C0.310663 10.7456 0.246007 10.569 0.249512 10.3936C0.249407 10.3888 0.248538 10.3837 0.248535 10.3789V6.75977C0.248682 6.39274 0.546566 6.09493 0.913574 6.09473C1.28075 6.09473 1.57847 6.39262 1.57861 6.75977V8.74316C2.26415 8.01902 3.07002 7.19698 3.97217 6.47852C5.45987 5.29382 7.31149 4.28917 9.54834 4.28906Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineUndo',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
